export default async function fetchAPI({
  uri,
  method,
  body,
  token,
  methodNextFetch = {}
}) {
  try {
    const base_url = `${process.env.WEBSITE_BASE_URL}/gon-proxy`; // process.env.BASE_URL;
    const namespace = process.env.NAME_SPACE;
    const db = process.env.BASE_URL_DATABASE;

    const newUri = `${base_url}/${namespace}/${db}/${uri}`;
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ` + token,
      "ngrok-skip-browser-warning": "skip"
    };
    !token && delete headers.Authorization;

    const payload = {
      method,
      headers,
      body: JSON.stringify(body)
    };
    !body && delete payload.body;

    const fetchPromise = await fetch(newUri, {
      ...payload,
      ...methodNextFetch
    });

    if (
      fetchPromise.ok ||
      fetchPromise.status == 404 ||
      fetchPromise.statusText == "Bad Request"
    )
      return await fetchPromise.json();
    throw new Error(fetchPromise.statusText);
  } catch (error) {
    console.error("fetchAPI = ", error);
    // throw new Error(error);
  }
}

export async function fetchAPIPersonal({
  uri,
  method,
  body,
  token,
  methodNextFetch = {}
}) {
  try {
    const newUri = `${process.env.NEXTAUTH_URL}/api/${uri}`;
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ` + token,
      "ngrok-skip-browser-warning": "skip"
    };
    !token && delete headers.Authorization;

    const payload = {
      method,
      headers,
      body: JSON.stringify(body)
    };
    !body && delete payload.body;

    const start = Date.now();

    const fetchPromise = fetch(newUri, { ...payload, methodNextFetch }).then(
      async (res) => {
        const duration = Date.now() - start;
        console.log(`FetchAPIPersonal duration for ${newUri}: ${duration}ms`);

        // Set Server-Timing header (if needed in server response)
        if (res.headers && res.headers.get("Server-Timing")) {
          res.headers.append("Server-Timing", `fetch;dur=${duration}`);
        }

        return res.json();
      }
    );

    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 25999)
    );

    const datas = await Promise.race([fetchPromise, timeoutPromise]);

    return datas;
  } catch (error) {
    console.log("fetchAPIPersonal = ", error?.message);
  }
}

export async function fetchAPIOther({
  uri,
  method,
  body,
  token,
  header,
  methodNextFetch = {}
}) {
  try {
    const newUri = uri;
    let headers = !header
      ? {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ` + token,
          "ngrok-skip-browser-warning": "skip"
        }
      : header;
    !token && delete headers.Authorization;

    const payload = {
      method,
      headers,
      body: JSON.stringify(body)
    };
    !body && delete payload.body;
    const res = await fetch(newUri, { ...payload, methodNextFetch });

    const datas = await res.json();
    return datas;
  } catch (error) {
    console.log("fetchAPIOther = ", error);
  }
}
